import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchCrisisSuccess, fetchCrisisError, loadMoreCrisisSuccess, loadMoreCrisisError, addCrisisSuccess, addCrisisError} from '../actions/Crisis';
import { getDocs, addDoc } from 'firebase/services/crisis';
import {FETCH_CRISIS, LOAD_MORE_CRISIS, ADD_CRISIS} from 'constants/ActionTypes';

const DEFAULT_LIMIT_PAGINATION = 20;

function* fetchCrisisRequest({ params }) {
  try {
    const fetchedCrisisList = yield call(getDocs, { lastDoc: null, limit: params.limit || DEFAULT_LIMIT_PAGINATION, filter: params.filter });
    yield put(fetchCrisisSuccess(fetchedCrisisList));
  } catch (error) {
    yield put(fetchCrisisError(error));
  }
}

function* loadMoreCrisisRequest({ params }) {
  try {
    const fetchedCrisisList = yield call(getDocs, { lastDoc: params.lastDoc || null, limit: params.limit || DEFAULT_LIMIT_PAGINATION, filter: params.filter });
    yield put(loadMoreCrisisSuccess(fetchedCrisisList));
  } catch (error) {
    console.log(error);
    yield put(loadMoreCrisisError(error));
  }
}

function* addCrisisRequest({ payload: { params } }) {
  try {
    const result = yield call(addDoc, {data: params});
    yield put(addCrisisSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addCrisisError(error));
  }
}

export function* loadMoreCrisis() {
  yield takeEvery(LOAD_MORE_CRISIS, loadMoreCrisisRequest);
}

export function* fetchCrisis() {
  yield takeEvery(FETCH_CRISIS, fetchCrisisRequest);
}

export function* addCrisis() {
  yield takeEvery(ADD_CRISIS, addCrisisRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchCrisis), fork(loadMoreCrisis), fork(addCrisis)]);
}
